import React from "react";
import NtSetupResourceList from "../NtSetupResourceList";
import NtSetupResourceCard from "../NtSetupResourceCard";
import NtExtensionNewForm from "../../../extensions/components/NtExtensionNewForm";
import { fetchExtensions } from "../../../api/extension";
import settings from "../../../config/settings";

const fetcher = (domain) =>
  fetchExtensions(domain, 1, settings.pageSizeLoad || 50);

const parseItems = (response) =>
  response?.data?.data || response?.data?.extensions || [];

function NtSetupExtensionsStep() {
  return (
    <NtSetupResourceList
      icon="account-multiple-outline"
      title="Team extensions"
      subtitle="Each person gets a 4-digit extension"
      addLabel="Add extension"
      emptyTitle="No extensions yet"
      emptySubtitle="Add your first extension. Invite teammates by name and assign them a 4-digit number."
      fetcher={fetcher}
      parseItems={parseItems}
      renderItem={(item, index, list) => (
        <NtSetupResourceCard
          key={item.extension_uuid || item.id || index}
          badge={item.extension || item.ext_extension}
          title={
            item.effective_caller_id_name ||
            item.caller_id_name ||
            item.description ||
            "Extension"
          }
          subtitle={item.description || item.user_email}
        />
      )}
      renderForm={({ onCancel, onCreate }) => (
        <NtExtensionNewForm onCancel={onCancel} onCreate={onCreate} />
      )}
    />
  );
}

export default NtSetupExtensionsStep;
